module.exports = __webpack_public_path__ + "static/pixel_text_mobile-db98f1657b2a26fe58d91b665cf0cd41.svg";